// @ts-nocheck
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FileSpreadsheet, Sparkles, ArrowLeft } from 'lucide-react';

/**
 * Inline sheet-picker rendered between upload and the agent run. The
 * caller passes the uploaded file metadata + the workbook's tab list;
 * confirming kicks off `onConfirm(sheetName)`. Cancelling resets the
 * agent surface back to the dropzone.
 *
 * Single-sheet workbooks should never reach this component — the caller
 * auto-confirms in that case so the user doesn't see a degenerate picker
 * with one option.
 */
const SheetPicker = ({ file, sheets, onConfirm, onCancel, submitting }) => {
  const [selected, setSelected] = useState(sheets?.[0] ?? '');

  const handleConfirm = () => {
    if (!selected || submitting) return;
    onConfirm(selected);
  };

  return (
    <motion.div
      className="agent-sheet-picker"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.22 }}
    >
      <div className="agent-sheet-picker-card">
        <div className="agent-sheet-picker-file">
          <FileSpreadsheet size={14} />
          <span className="agent-sheet-picker-filename" title={file?.filename}>
            {file?.filename}
          </span>
        </div>

        <h2 className="agent-sheet-picker-title">Which sheet should I map?</h2>
        <p className="agent-sheet-picker-sub">
          This workbook has {sheets.length} tabs. Pick the one with the P&amp;L —
          the agent will run end-to-end on that sheet.
        </p>

        <div className="agent-sheet-picker-list">
          {sheets.map((name) => (
            <button
              type="button"
              key={name}
              className={`agent-sheet-option ${selected === name ? 'selected' : ''}`}
              onClick={() => !submitting && setSelected(name)}
              disabled={submitting}
            >
              <span className="agent-radio-circle">
                {selected === name && <span className="agent-radio-dot" />}
              </span>
              <span className="agent-sheet-option-name">{name}</span>
            </button>
          ))}
        </div>

        <div className="agent-sheet-picker-actions">
          <button
            type="button"
            className="agent-sheet-picker-cancel"
            onClick={onCancel}
            disabled={submitting}
          >
            <ArrowLeft size={12} style={{ marginRight: 4 }} />
            Pick a different file
          </button>
          <button
            type="button"
            className="agent-sheet-picker-confirm"
            onClick={handleConfirm}
            disabled={!selected || submitting}
          >
            <Sparkles size={13} style={{ marginRight: 6 }} />
            {submitting ? 'Starting…' : 'Start mapping'}
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default SheetPicker;
